module.exports = __webpack_public_path__ + "img/landing_background.6d5710d1.jpg";